export class Layer {
	constructor(image, width, height, groundOffset, speedModifire, game) {
		this.game = game;
		this.groundOffset = groundOffset;
		this.startWidth = width;
		this.startHeight = height;
		this.x = 0;
		this.y = this.game.height - this.groundOffset;
		this.width = width;
		this.height = height;
		this.x2 = this.width;
		this.image = image;
		this.speedModifire = speedModifire;
		this.speed = this.game.speed * this.speedModifire;
	}

	update() {
		this.x -= this.speed;

		if (this.x < 0 - this.width) {
			this.x = 0;
		}
	}

	draw() {
		this.game.ctx.drawImage(this.image, this.x, this.y, this.width, this.height);
		this.game.ctx.drawImage(this.image, this.x + this.width, this.y, this.width, this.height);
	}

	resize() {
		// this.x = this.startX;
		this.y = this.game.height - this.groundOffset;
		this.width = this.startWidth;
		this.height = this.startHeight;
		// this.x2 = this.width;
	}
}
